import { useTranslation } from "react-i18next";
import { parseWorkTime } from "utils/utils";
import {
  AmountInput,
  AmountInputShell,
  AmountSuffix,
  DistributionCell,
  DistributionGrid,
  DistributionHeaderCell,
  WorkerAvatar,
  WorkerIdentity,
  WorkerName,
} from "./tips.distributionModal.styled";
import {
  getWorkerInitials,
  getWorkerName,
  toAmountInputValue,
} from "./tips.distributionModal.logic";
import type {
  EditableTipEntry,
  HandleWorkerAmountChangeParams,
} from "./tips.distributionModal.types";

interface TipsDistributionHourRowsProps {
  readonly editableTipEntries: readonly EditableTipEntry[];
  readonly onWorkerAmountChange: (
    params: HandleWorkerAmountChangeParams,
  ) => void;
}

export const TipsDistributionHourRows = (
  props: TipsDistributionHourRowsProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <DistributionGrid>
      <DistributionHeaderCell>
        {t("Tips.DistributionWorker")}
      </DistributionHeaderCell>
      <DistributionHeaderCell>
        {t("Tips.DistributionApprovedHours")}
      </DistributionHeaderCell>
      <DistributionHeaderCell>
        {t("Tips.DistributionAmount")}
      </DistributionHeaderCell>
      {props.editableTipEntries.flatMap(([date, tip]) =>
        tip.workers.map((worker, workerIndex) => {
          const workTime = parseWorkTime(worker.workTime);
          return [
            <DistributionCell key={`${date}-${worker.workerId}-name`}>
              <WorkerIdentity>
                <WorkerAvatar>{getWorkerInitials(worker)}</WorkerAvatar>
                <WorkerName>{getWorkerName(worker)}</WorkerName>
              </WorkerIdentity>
            </DistributionCell>,
            <DistributionCell key={`${date}-${worker.workerId}-hours`}>
              {workTime.hours}
              {t("General.HourShortened")}
              {workTime.minutes > 0
                ? ` ${workTime.minutes}${t("General.MinutesShortened")}`
                : ""}
            </DistributionCell>,
            <DistributionCell key={`${date}-${worker.workerId}-amount`}>
              <AmountInputShell>
                <AmountInput
                  aria-label={t("Tips.DistributionAmountForWorker", {
                    worker: getWorkerName(worker),
                  })}
                  inputMode="numeric"
                  onChange={(event) =>
                    props.onWorkerAmountChange({
                      date,
                      value: event.target.value,
                      workerIndex,
                    })
                  }
                  value={toAmountInputValue(worker.tipAmount)}
                />
                <AmountSuffix>{t("Tips.Currency")}</AmountSuffix>
              </AmountInputShell>
            </DistributionCell>,
          ];
        }),
      )}
    </DistributionGrid>
  );
};
